export default "__VITE_ASSET__fbQLK0HE__"